export function Get() {
    return {
        Text: '',
        Price: 0,
        Quantity: 0,
        ItemId: 0,
        LineType: 0,
        Editable: false,
        ProductionPrinted: 0,
        SimpleSeparator: false,
        KeyId: 0,
        ProductionProcessed: true,
        RegistrationDateTime: new Date(),
        TicketStartDate: null,
        TicketEndDate: null,
        VatID:0,
    };
}

export function GetOptional() {
    return {
        Configuration: [],
        ConfigurationEdit: false,
        CustomerId: 0,
        TransactionLogId: 0,
        Weight: 0,
        TicketBarcode: '',
        TicketStartDate: null,
        TicketEndDate: null,
    }
}


// WEBPACK FOOTER //
// src/models/ReceiptLine.js